import * as Constants from "../common/Constants";

const initialState = {
    stocks: [],
    currentClientId: 0,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    //count: 0,
    //page: 1,
    //pageSize: 10,
    error: null
};

export default function distributorStockReducer(state = initialState, action) {

    switch (action.type) {

        case Constants.REQUEST_UPDATE_DISTRIBUTOR_STOCK:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_UPDATE_DISTRIBUTOR_STOCK:
            var newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_UPDATE_DISTRIBUTOR_STOCK:
        case Constants.FAILED_GET_DISTRIBUTOR_STOCK:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_DISTRIBUTOR_STOCK:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            //newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.SUCCESS_GET_DISTRIBUTOR_STOCK:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.stocks = action.payload;
            newState.currentClientId = (action.payload.length > 0) ? action.payload[0].distributorId : 0;

            return newState;

        case Constants.RESET_DISTRIBUTOR_STOCK:
            var newState = { ...state };
            newState.stocks = [];
            newState.currentClientId = 0;
            newState.isLoading = false;
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/DistributorStockReducer.js